import { Autocomplete, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

import useDebouncedState from "~/shared/hooks/useDebouncedState";

import useSpeciesSelect_GetAutocompleteOptions from "./api/useSpeciesSelect_GetAutocompleteOptions";
import { SpeciesSelectMultipleProps } from "./types";

export default function SpeciesSelectMultiple({
    value,
    onChange,
    disabled,
    label,
    excludeAssignedToResearchTypeId,
    error,
    helperText,
}: SpeciesSelectMultipleProps) {
    const { t } = useTranslation("shared");

    const [searchQuery, debouncedSearchQuery, setSearchQuery] = useDebouncedState("");

    const { options, selectedOptions, loading } = useSpeciesSelect_GetAutocompleteOptions({
        q: debouncedSearchQuery || undefined,
        excludeAssignedToResearchTypeId,
        selectedIds: value,
    });

    return (
        <Autocomplete
            multiple
            noOptionsText={t("SpeciesSelect.noOptionsFoundLabel")}
            disabled={disabled}
            filterOptions={x => x}
            getOptionLabel={option => option.label}
            getOptionKey={option => option.value}
            isOptionEqualToValue={(option, selectedOption) => option.value === selectedOption.value}
            loading={loading}
            inputValue={searchQuery}
            onInputChange={(_, newInputValue, reason) => {
                if (reason === "reset") return;
                setSearchQuery(newInputValue);
            }}
            options={options}
            value={selectedOptions}
            onChange={(_, nextValue) => onChange(nextValue.map(x => x.value))}
            renderInput={params => (
                <TextField
                    {...params}
                    label={label}
                    error={error}
                    helperText={helperText}
                    placeholder={value.length === 0 ? t("SpeciesSelect.typeToSearchLabel") : undefined}
                    variant="outlined"
                />
            )}
        />
    );
}
